import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollController() {
  const { pathname, hash } = useLocation() as unknown as { pathname: string; hash?: string };

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (hash && hash.length > 1) {
      const raw = hash.slice(1);
      const looksLikeParams = raw.includes('=') || raw.includes('&');

      if (!looksLikeParams) {
        const safeSelector = '#' + (typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(raw) : raw);
        const tryScroll = (attempts = 0) => {
          try {
            const el = document.querySelector(safeSelector);
            if (el) {
              el.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
              return;
            }
          } catch {
            // invalid selector – bail out gracefully
            return;
          }
          if (attempts < 10) requestAnimationFrame(() => tryScroll(attempts + 1));
        };
        tryScroll();
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
